import React from 'react';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Row, Col, Button, FormGroup, InputGroup, InputGroupAddon } from 'reactstrap';

const PostersField = ({ fields, t }) => {
    return (
        <div className="PostersField">
            {(fields || []).map((poster, index) => (
                <Row key={index} className="mb-2">
                    <Col sm={10}>
                        <FormGroup className="mb-0">
                            <InputGroup>
                                <Field
                                    component="input"
                                    type="text"
                                    className="form-control"
                                    name={`${poster}.url`}
                                    placeholder="https://..."
                                />
                                <InputGroupAddon addonType="append">
                                    <Button color="danger" onClick={() => fields.remove(index)}>
                                        <i className="fa fa-trash"></i>
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                    </Col>
                </Row>
            ))}
            <Button color="info" size="sm" onClick={() => fields.push({ url: "" })}>
                <i className="fa fa-plus"></i>&nbsp;{t("common.add")}
            </Button>
        </div>
    );
};

export default withTranslation("translations")(PostersField);
